import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class HubsSubjectsSubtree extends Resource {
  public static type = 'hubs_subjects_subtree';

  @prop
  public subtreeIds: Array<string>;
}
